import { Injectable } from "@angular/core";
import { IID_SLAEDITOR } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDSLAEditorStore } from "./iidSLAEditor.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.SLA_EDITOR)
export class IIDSLAEditorQuery extends AbstractInterfaceDataQuery<IID_SLAEDITOR> {
  constructor(protected store: IIDSLAEditorStore) {
    super(store);
  }
}
